import React, { useMemo } from 'react';
import { motion } from 'framer-motion';

/**
 * Lightweight CSS-particle confetti burst (no external lib).
 * Renders 40 colored dots that fly out and fade.
 */
export const ConfettiBurst = ({ show = true, count = 40 }) => {
  const particles = useMemo(() => {
    if (!show) return [];
    const colors = ['#1A4331', '#34D399', '#FBBF24', '#F97316', '#10B981'];
    return Array.from({ length: count }, (_, i) => ({
      id: i,
      x: (Math.random() - 0.5) * 480,
      y: -Math.random() * 320 - 60,
      rotate: Math.random() * 540 - 270,
      delay: Math.random() * 0.25,
      color: colors[i % colors.length],
      size: 6 + Math.random() * 6,
    }));
  }, [show, count]);

  if (!show) return null;

  return (
    <div className="pointer-events-none absolute inset-0 flex items-center justify-center overflow-hidden" aria-hidden>
      {particles.map((p) => (
        <motion.span
          key={p.id}
          initial={{ opacity: 1, x: 0, y: 0, rotate: 0, scale: 0 }}
          animate={{ opacity: [1, 1, 0], x: p.x, y: p.y, rotate: p.rotate, scale: 1 }}
          transition={{ duration: 1.6, delay: p.delay, ease: [0.16, 1, 0.3, 1] }}
          style={{
            width: p.size,
            height: p.size * 0.4,
            background: p.color,
            borderRadius: 2,
            position: 'absolute',
          }}
        />
      ))}
    </div>
  );
};

export default ConfettiBurst;
